<template>
  <div class="container">
    <el-form ref="form" :rules="rules" :model="form" label-width="auto">
      <el-row>
        <el-col :span="6">
          <el-form-item prop="educationTypeCode" label="办学形式：">
            <el-select
              size="small"
              :disabled="status === 'info'"
              v-model="form.educationTypeCode"
              placeholder="请选择"
            >
              <el-option
                v-for="item in educationTypeCodeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="9" :push="1">
          <el-form-item prop="albumTitle" label="班级名称：">
            <el-input
              size="small"
              :disabled="status === 'info'"
              v-model="form.albumTitle"
              :maxlength="120"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="display: flex; align-items: center">
        <el-col :span="9">
          <el-form-item prop="classCode" label="班级编码：">
            <el-input
              size="small"
              :disabled="status === 'info'"
              v-model="form.classCode"
              :maxlength="200"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="2" :push="1">
          <el-button size="small" type="primary">自动关联匹配</el-button>
        </el-col> -->
      </el-row>

      <el-row>
        <el-col :span="9">
          <el-form-item prop="locId" label="办学院校：">
            <el-select
              size="small"
              :disabled="status === 'info'"
              v-model="form.locId"
              placeholder="-请选择-"
              @change="getMajorList"
            >
              <el-option
                v-for="item in locIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" :push="1">
          <el-form-item prop="majorId" label="开考专业：">
            <el-select
              size="small"
              v-model="form.majorId"
              :disabled="status === 'info'"
              placeholder="-请选择-"
            >
              <el-option
                v-for="item in majorIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="6">
          <el-form-item prop="bxms" label="办学模式：">
            <el-select
              size="small"
              v-model="form.bxms"
              placeholder="-请选择-"
              :disabled="status === 'info'"
            >
              <el-option
                v-for="item in bxmsList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" :push="1">
          <el-form-item prop="xxxs" label="学习形式：">
            <el-select
              size="small"
              v-model="form.xxxs"
              placeholder="-请选择-"
              :disabled="status === 'info'"
            >
              <el-option
                v-for="item in xxxsList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" :push="2">
          <el-form-item prop="partnerSchool" label="合作院校：">
            <el-select
              size="small"
              v-model="form.partnerSchool"
              placeholder="-请选择-"
              :disabled="status === 'info'"
            >
              <el-option
                v-for="item in partnerSchoolList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <!-- <el-input
              size="small"
              :disabled="status === 'info'"
              v-model="form.partnerSchool"
              :maxlength="100"
            ></el-input> -->
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="6">
          <el-form-item prop="partnerInstitution" label="合作机构：">
            <el-select
              size="small"
              v-model="form.partnerInstitution"
              placeholder="-请选择-"
              :disabled="status === 'info'"
            >
              <el-option
                v-for="item in partnerInstitutionList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <!-- <el-input
              size="small"
              :disabled="status === 'info'"
              v-model="form.partnerInstitution"
              :maxlength="100"
            ></el-input> -->
          </el-form-item>
        </el-col>
        <el-col :span="6" :push="1">
          <el-form-item prop="year" label="年度：">
            <el-date-picker
              v-model="form.year"
              type="year"
              :disabled="status === 'info'"
              placeholder="选择年"
              value-format="yyyy"
              size="small"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6" :push="2">
          <el-form-item prop="term" label="学期：">
            <el-select
              size="small"
              v-model="form.term"
              placeholder="-请选择-"
              :disabled="status === 'info'"
            >
              <el-option
                v-for="item in termList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="6">
          <el-form-item prop="classNumber" label="班级编号：">
            <el-input
              size="small"
              v-model="form.classNumber"
              :disabled="status === 'info'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" :push="1">
          <el-form-item prop="videoUndertakingId" label="承诺书：">
            <el-select
              size="small"
              v-model="form.videoUndertakingId"
              placeholder="-请选择承诺书-"
              :disabled="status === 'info'"
            >
              <el-option
                v-for="item in videoUndertakingIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" :push="2">
          <el-form-item prop="isOvert" label="是否公开报名：">
            <el-radio
              :disabled="status === 'info'"
              v-model="form.isOvert"
              label="0"
              >否</el-radio
            >
            <el-radio
              :disabled="status === 'info'"
              v-model="form.isOvert"
              label="1"
              >是</el-radio
            >
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="display: flex; align-items: center">
        <el-col :span="6">
          <el-form-item prop="applyType" label="报名方式：">
            <el-select
              size="small"
              @change="handleChangeApplyType"
              v-model="form.applyType"
              :disabled="status === 'info'"
              placeholder="-请选择报名方式-"
            >
              <el-option
                v-for="item in applyTypeList"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" class="verify_desc">
          <div v-if="form.applyType == 1">
            说明：本方式需要<span class="tips">审核且报名收费</span
            >，学员需要先提交报名信息且缴费后，再进行报名资格审核。
          </div>
          <div v-else-if="form.applyType == 2">
            说明：本方式需要<span class="tips">审核且报名收费</span
            >，学员需要先提交报名信息且缴费后，再进行报名资格审核。
          </div>
          <div v-else-if="form.applyType == 3">
            说明：本方式需要<span class="tips">报名免费</span
            >，学员提交报名信息进行审核，审核通过后无需缴费。
          </div>
          <div v-else-if="form.applyType == 4">
            说明：本方式需要<span class="tips">报名收费</span
            >，学员只需进行报名缴费，不对学员信息进行审核。
          </div>
          <div v-else-if="form.applyType == 5">
            说明：本方式需要<span class="tips">报名公开免费</span
            >，学员报名后即可学习，无需审核无需缴费。
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="16">
          <el-form-item prop="signupInfoIds" label="报名信息：">
            <el-checkbox-group
              v-model="form.signupInfoIds"
              :disabled="status === 'info'"
            >
              <el-checkbox label="1" disabled>姓名</el-checkbox>
              <el-checkbox label="2">准考证号</el-checkbox>
              <el-checkbox label="3">身份证号</el-checkbox>
              <el-checkbox label="4">手机号</el-checkbox>
              <el-checkbox label="5">微信号</el-checkbox>
              <el-checkbox label="6">邮箱</el-checkbox>
              <el-checkbox label="7">考生来源</el-checkbox>
              <el-checkbox label="8">层次</el-checkbox>
              <el-checkbox label="9">是否申请学士学位</el-checkbox>
              <el-checkbox label="11" disabled>专业</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="display: flex; align-items: center">
        <el-col :span="6">
          <el-form-item prop="price" label="价格：">
            <el-input-number
              size="small"
              v-model="form.price"
              :min="0"
              :max="9999999"
              :disabled="status === 'info'"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="1"> 元 </el-col>
      </el-row>

      <el-row>
        <el-col :span="6">
          <el-form-item prop="mhmId" label="机构名称：">
            <el-select
              size="small"
              v-model="form.mhmId"
              placeholder="-请选择机构名称-"
              :disabled="disabledMhmId || status === 'info'"
            >
              <el-option
                v-for="item in mhmIdList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" :push="1">
          <el-form-item prop="classAdviserId" label="班主任：">
            <el-select
              size="small"
              v-model="form.classAdviserId"
              placeholder="-默认登录人-"
              :disabled="disableClassAdviserId || status === 'info'"
            >
              <el-option
                v-for="item in classAdviserIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="display: flex; align-items: center">
        <el-col :span="6">
          <el-form-item prop="classMaxNum" label="班级最大人数：">
            <el-input-number
              size="small"
              v-model="form.classMaxNum"
              :min="0"
              :max="9999"
              :disabled="status === 'info'"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6" :push="1">
          <el-form-item prop="classNum" label="最少开班人数：">
            <el-input-number
              size="small"
              v-model="form.classNum"
              :min="0"
              :max="9999"
              :disabled="status === 'info'"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6" :push="1" style="margin-left: 30px; color: #aaa">
          单位：人，0为不设人数限制
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="6">
          <el-form-item prop="signupStarttime" label="报名开始时间：">
            <el-date-picker
              v-model="form.signupStarttime"
              type="datetime"
              placeholder="选择日期时间"
              style="width: 100%"
              size="small"
              :disabled="status === 'info' || handleCourseDtae(1)"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6" :push="1">
          <el-form-item prop="signupEndtime" label="报名截止时间：">
            <el-date-picker
              v-model="form.signupEndtime"
              type="datetime"
              placeholder="选择日期时间"
              style="width: 100%"
              size="small"
              :disabled="status === 'info' || handleCourseDtae(2)"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="6">
          <el-form-item prop="openClassTime" label="开班时间：">
            <el-date-picker
              v-model="form.openClassTime"
              type="datetime"
              placeholder="选择日期时间"
              style="width: 100%"
              size="small"
              :disabled="status === 'info' || handleCourseDtae(3)"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6" :push="1">
          <el-form-item prop="closeClassTime" label="结班时间：">
            <el-date-picker
              v-model="form.closeClassTime"
              type="datetime"
              :disabled="status === 'info' || handleCourseDtae(4)"
              placeholder="选择日期时间"
              style="width: 100%"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item prop="payTime" label="缴费截止时间：">
            <el-date-picker
              v-model="form.payTime"
              type="datetime"
              placeholder="选择日期时间"
              style="width: 100%"
              size="small"
              :disabled="status === 'info'"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="10">
          <el-form-item prop="fileId" label="封面：">
            <div style="display: flex">
              <el-upload
                v-if="status !== 'info'"
                class="upload-demo"
                :action="url + '/zkfz/file/addUploadFile'"
                :before-upload="beforeUpload"
                :on-success="successUp"
                :on-error="errorUp"
                :on-change="changeUpload"
                :on-remove="removeFile"
                multiple
                :file-list="fileList"
              >
                <el-button size="small" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">
                  建议尺寸：580px*320px
                </div>
              </el-upload>
              <div v-if="status !== 'add'">
                <img
                  style="max-height: 150px"
                  :src="form.url"
                  alt="图片加载失败"
                />
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item prop="vIds" label="包含课程：">
            <div v-if="choseTableData.length < 1">
              <el-button size="small" type="primary" @click="chooseCourse">
                选择课程
              </el-button>
            </div>
            <div v-else>
              <div>绑定下列课程</div>
              <el-table
                :data="choseTableData"
                max-height="400"
                style="width: 100%; margin-top: 0"
                :header-cell-style="{ 'background-color': '#f2f2f2' }"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  width="55"
                ></el-table-column>
                <el-table-column
                  prop="video_title"
                  label="课程名称"
                ></el-table-column>
                <el-table-column
                  prop="course_code"
                  label="课程代码"
                ></el-table-column>
                <el-table-column
                  prop="video_type_title"
                  label="课程性质"
                ></el-table-column>
                <el-table-column
                  prop="title"
                  label="学校机构"
                ></el-table-column>
                <el-table-column prop="name" label="课程讲师">
                </el-table-column>
              </el-table>
              <el-button
                size="small"
                type="primary"
                v-if="status !== 'info' || handleCourseDtae(4)"
                @click="chooseCourse"
              >
                绑定更多课程
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="6">
          <el-form-item prop="showPlace" label="展示位置：">
            <el-radio
              v-model="form.showPlace"
              :label="false"
              :disabled="status === 'info'"
              >机构及平台</el-radio
            >
            <el-radio
              v-model="form.showPlace"
              :label="true"
              :disabled="status === 'info'"
              >机构</el-radio
            >
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item prop="albumIntro" label="简介：" style="margin-top: 6px">
        <quill-editor
          ref="quillEditor"
          :disabled="status === 'info'"
          v-model="form.albumIntro"
          :options="options"
          style="width: 80%"
        >
          <div id="toolbar" slot="toolbar">
            <button class="ql-bold" title="加粗">Bold</button>
            <button class="ql-italic" title="斜体">Italic</button>
            <button class="ql-underline" title="下划线">underline</button>
            <button class="ql-strike" title="删除线">strike</button>
            <button class="ql-blockquote" title="引用"></button>
            <button class="ql-code-block" title="代码"></button>
            <button class="ql-list" value="ordered" title="有序列表"></button>
            <button class="ql-list" value="bullet" title="无序列表"></button>
            <button class="ql-indent" value="+1" title="首行缩进">
              indent
            </button>
            <select class="ql-header" title="段落格式">
              <option selected>段落</option>
              <option value="1">标题1</option>
              <option value="2">标题2</option>
              <option value="3">标题3</option>
              <option value="4">标题4</option>
              <option value="5">标题5</option>
              <option value="6">标题6</option>
            </select>
            <select class="ql-size" title="字体大小">
              <option value="10px">10px</option>
              <option value="12px">12px</option>
              <option value="14px">14px</option>
              <option value="16px" selected>16px</option>
              <option value="18px">18px</option>
              <option value="20px">20px</option>
            </select>
            <select class="ql-font" title="字体">
              <option value="SimSun" selected></option>
              <option value="SimHei"></option>
              <option value="Microsoft-YaHei"></option>
              <option value="KaiTi"></option>
              <option value="FangSong"></option>
              <option value="Arial"></option>
              <option value="Times-New-Roman"></option>
              <option value="sans-serif"></option>
            </select>
            <select class="ql-color" value="color" title="字体颜色"></select>
            <select
              class="ql-background"
              value="background"
              title="背景颜色"
            ></select>
            <select class="ql-align" value="align" title="对齐"></select>
            <button class="ql-clean" title="还原"></button>
          </div>
        </quill-editor>
      </el-form-item>
      <div
        style="display: flex; justify-content: center; margin-top: 30px"
        v-if="status === 'add'"
      >
        <el-checkbox v-model="continuous">连续录入</el-checkbox>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 10px">
        <el-button
          size="small"
          type="primary"
          @click="submit"
          v-if="status !== 'info'"
          >保存</el-button
        >
        <el-button size="small" type="info" @click="goBack">返回</el-button>
      </div>
    </el-form>

    <ChooseCourse
      v-if="chooseCourseVisible"
      :albumId="albumId"
      :choseData="choseTableData"
      @closeChooseCourse="closeChooseCourse"
    />
  </div>
</template>

<script>
import ChooseCourse from './chooseCourse.vue'
import * as api from '@/api/ClassManagement/addClass.js'
import * as api2 from '@/api/courseware/checkCourseware'
import * as api3 from '@/api/ClassManagement/chooseCourse.js'
import { Quill, quillEditor } from 'vue-quill-editor' //调用编辑器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/css/quill.css'

// 自定义字体大小
const Size = Quill.import('attributors/style/size')
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px']
Quill.register(Size, true)

// 自定义字体类型
const fonts = [
  'simSum',
  'SimHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong',
  'Arial',
  'Times-New-Roman',
  'sans-serif',
]
const Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

export default {
  components: {
    ChooseCourse,
    quillEditor,
  },
  props: {
    userType: {
      type: String,
    },
    params: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const validateFileId = (rule, value, callback) => {
      console.log('validateFileId', this.form.fileId, this.form.url)
      if (this.form.fileId || this.form.url) {
        callback()
      } else {
        callback(new Error('必须选择'))
      }
    }
    const validateChoose = (rule, value, callback) => {
      if (this.choseTableData && this.choseTableData.length) {
        callback()
      } else {
        callback(new Error('必须选择'))
      }
    }

    const validatorPayTime = (rule, value, callback) => {
      if (!value) {
        callback(new Error('必须选择'))
      } else {
        let flag = this.form.payTime > this.form.signupEndtime
        console.log('validatorPayTime', this.form, flag, value)
        if (flag) {
          callback()
        } else {
          callback(new Error('缴费报名时间不能早于报名截止时间'))
        }
      }
    }
    return {
      form: {
        id: '',
        uid: '',
        isDel: '',
        educationTypeCode: '1',
        albumTitle: '',
        classCode: '',
        locId: '',
        majorId: '',
        bxms: '',
        xxxs: '',
        partnerSchool: '',
        partnerInstitution: '',
        year: '',
        term: '',
        classNumber: '',
        videoUndertakingId: '',
        isOvert: '1',
        applyType: '',
        signupInfoIds: ['1', '11'],
        price: '',
        mhmId: '',
        classAdviserId: '',
        classMaxNum: null,
        classNum: 0,
        signupStarttime: '',
        signupEndtime: '',
        openClassTime: '',
        closeClassTime: '',
        fileId: '',
        showPlace: false,
        albumIntro: '',
        payTime: '',
      },
      rules: {
        educationTypeCode: [
          { required: true, message: '必须选择', trriger: 'blur' },
        ],
        albumTitle: [{ required: true, message: '必须填写', trriger: 'blur' }],
        classCode: [{ required: true, message: '必须填写', trriger: 'blur' }],
        locId: [{ required: true, message: '必须选择', trriger: 'blur' }],
        majorId: [{ required: true, message: '必须选择', trriger: 'blur' }],
        bxms: [{ required: true, message: '必须选择', trriger: 'blur' }],
        xxxs: [{ required: true, message: '必须选择', trriger: 'blur' }],
        year: [{ required: true, message: '必须填写', trriger: 'blur' }],
        term: [{ required: true, message: '必须选择', trriger: 'blur' }],
        classNumber: [{ required: true, message: '必须填写', trriger: 'blur' }],
        videoUndertakingId: [
          { required: true, message: '必须选择', trriger: 'blur' },
        ],
        isOvert: [{ required: true, message: '必须选择', trriger: 'blur' }],
        applyType: [{ required: true, message: '必须选择', trriger: 'blur' }],
        signupInfoIds: [
          {
            required: true,
            type: 'array',
            message: '必须选择',
            trriger: 'blur',
          },
        ],
        price: [
          {
            required: true,
            message: '必须填写',
            trriger: 'blur',
            type: 'number',
          },
        ],
        mhmId: [
          {
            required: true,
            type: 'number',
            message: '必须选择',
            trriger: 'blur',
          },
        ],
        classAdviserId: [
          { required: true, message: '必须选择', trriger: 'blur' },
        ],
        classMaxNum: [
          {
            required: true,
            message: '必须填写',
            trriger: 'blur',
            type: 'number',
          },
        ],
        signupStarttime: [
          { required: true, message: '必须选择', trriger: 'blur' },
        ],
        signupEndtime: [
          { required: true, message: '必须选择', trriger: 'blur' },
        ],
        payTime: [
          { required: true, trriger: 'blur', validator: validatorPayTime },
        ],
        openClassTime: [
          { required: true, message: '必须选择', trriger: 'blur' },
        ],
        closeClassTime: [
          { required: true, message: '必须选择', trriger: 'blur' },
        ],
        fileId: [
          {
            required: true,
            message: '必须选择',
            trriger: 'blur',
            validator: validateFileId,
          },
        ],
        vIds: [{ required: true, validator: validateChoose, trriger: 'blur' }],
        albumIntro: [{ required: true, message: '必须填写', trriger: 'blur' }],
      },
      educationTypeCodeList: [
        {
          label: '自学考试',
          value: '1',
        },
        {
          label: '成人教育',
          value: '2',
        },
        {
          label: '网络教育',
          value: '3',
        },
        {
          label: '高端培训',
          value: '4',
        },
      ],
      locIdList: [],
      majorIdList: [],
      bxmsList: [
        {
          label: '公开学院',
          value: '1',
        },
        {
          label: '相沟通',
          value: '2',
        },
        {
          label: '本科二学历',
          value: '3',
        },
        {
          label: '社会助学',
          value: '4',
        },
        {
          label: '课程培训',
          value: '5',
        },
      ],
      xxxsList: [
        {
          label: '业余',
          value: '1',
        },
        {
          label: '集中',
          value: '2',
        },
        {
          label: '自主',
          value: '3',
        },
      ],
      termList: [
        {
          label: '秋季学期',
          value: '1',
        },
        {
          label: '春季学期',
          value: '2',
        },
        {
          label: '夏季学期',
          value: '3',
        },
      ],
      videoUndertakingIdList: [],
      applyTypeList: [
        {
          key: '1',
          value: '先审核后缴费',
        },
        {
          key: '2',
          value: '先缴费后审核',
        },
        {
          key: '3',
          value: '仅审核无缴费',
        },
        {
          key: '4',
          value: '无审核仅缴费',
        },
        {
          key: '5',
          value: '无审核无缴费',
        },
      ],
      mhmIdList: [],
      disabledMhmId: false,
      classAdviserIdList: [],
      disableClassAdviserId: false,
      fileList: [],
      chooseCourseVisible: false,
      options: {
        placeholder: '请输入内容',
        theme: 'snow',
        modules: {
          toolbar: '#toolbar',
        },
      },
      continuous: false,
      choseTableData: [],
      status: '',
      initEidtChoseIds: [],
      albumId: null,
      partnerSchoolList: [],
      partnerInstitutionList: [],
    }
  },
  created() {
    this.initForm = { ...this.form }
    this.getLocationList()
    this.getUndertakingList()
    this.getOrganLists()
    this.getClassAdviserList()
    this.getPartnerSchool()
    this.getPartnerInstitution()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  methods: {
    async getSchoolByUid() {
      const { code, data } = (await api2.getSchoolByUid(this.getUId)).data
      if (code === 100000) {
        this.form.mhmId = data.id
        // this.$refs.form.validateField('mhmId')
      }
    },
    async getPartnerSchool() {
      const { code, data } = (await api.getPartnerSchool()).data
      if (code === 100000) {
        this.partnerSchoolList = data
        console.log(' this.partnerSchoolList', this.partnerSchoolList, data)
      }
    },
    async getPartnerInstitution() {
      const { code, data } = (await api.getPartnerInstitution()).data
      if (code === 100000) {
        this.partnerInstitutionList = data
        console.log('this.partnerInstitutionList', this.partnerInstitutionList)
      }
    },
    async getLocationList() {
      const { code, data } = (await api.getLocationList()).data
      if (code === 100000) {
        this.locIdList = data.map((item) => {
          return { ...item, name: item.code + '(' + item.name + ')' }
        })
      }
    },
    async getMajorList() {
      if (this.form.locId) {
        this.form.majorId = ''
        console.log('this.locIdList', this.locIdList, this.form.locId)
        let obj = this.locIdList.find((item) => item.id === this.form.locId)
        if (obj && obj.code) {
          const { code, data } = (await api.getMajorList({ localId: obj.code }))
            .data
          if (code === 100000) {
            this.majorIdList = data

          }
        }
      }
    },
    async getUndertakingList() {
      const { code, data } = (await api.getUndertakingList()).data
      if (code === 100000) {
        this.videoUndertakingIdList = data
      }
    },
    async getOrganLists() {
      const { code, data } = (await api.getOrganLists()).data
      if (code === 100000) {
        this.mhmIdList = data.list
        if (this.userType !== '1') {
          this.disabledMhmId = true
          this.getSchoolByUid()
        }
      }
    },
    async getClassAdviserList() {
      const { code, data } = (await api.getClassAdviserList()).data
      if (code === 100000) {
        this.classAdviserIdList = data
        if (this.userType === '53') {
          this.disableClassAdviserId = true
          this.form.classAdviserId = data.find(
            (item) => item.code === this.getUId
          ).id
        }
      }
    },
    beforeUpload(file) {
      let types = ['image/jpeg', , 'image/jpg', 'image/png']
      const isImage = types.includes(file.type)
      // const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        return this.$message.error('上传图片只能是 JPEG、JPG、PNG 格式!')
      }
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!')
      // }
      // return isImage && isLt2M
    },
    changeUpload(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    successUp(res, file, fileList) {
      let formdata = new FormData()
      formdata.append('file', file.raw)
      if (res.code === 100000) {
        this.form.fileId = res.data
        this.$refs.form.validateField('fileId')
        api2.beforeSaveUpload(res.data).then(({ data }) => {
          this.fileSrc = data.data.url
        })
      } else {
        this.$message.error(res.msg)
      }
    },
    errorUp(err, file, fileList) {
      return this.$message.error(err)
    },
    removeFile() {
      this.form.fileId = ''
      this.form.url = ''
    },
    chooseCourse() {
      this.chooseCourseVisible = true
    },
    closeChooseCourse(choseTableData) {
      this.chooseCourseVisible = false
      if (choseTableData) {
        this.choseTableData = choseTableData
      }
    },
    handleChangeApplyType(val) {
      console.log('val', val)
      if (val == 4 || val == 5) {
        this.form.signupInfoIds = ['1', '11']
      } else {
        this.form.signupInfoIds = [
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9',
          '11',
        ]
      }
    },
    submit() {
      let addIds = []
      let deleteIds = []
      if (this.choseTableData.length > 0) {
        let ids = []
        this.choseTableData.forEach((item) => {
          ids.push(item.id)
        })
        addIds = ids.filter((item) => !this.initEidtChoseIds.includes(item))
        deleteIds = this.initEidtChoseIds.filter((item) => !ids.includes(item))
      }
      console.log(
        'this.choseTableData',
        this.choseTableData,
        this.form,
        addIds,
        deleteIds
      )
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.form.uid = this.getUId
          if (this.userType === '1' || this.userType === '52') {
            this.form.isDel = '2'
          } else {
            this.form.isDel = '0'
          }

          console.log('this.form', this.form)
          const { code, msg } = (
            await api.saveOrUpdate({
              ...this.form,
              addIds: addIds.length && addIds.join(','),
              deleteIds: deleteIds.length && deleteIds.join(','),
              signupInfoIds:
                (this.form.signupInfoIds &&
                  this.form.signupInfoIds.join(',')) ||
                '',
            })
          ).data
          if (code === 100000) {
            this.$refs.form.resetFields()
            this.fileList = []
            this.choseTableData = []
            this.$message.success(msg)
            if (!this.continuous) {
              this.goBack()
            }
          } else {
            this.$message.error('保存失败')
          }
        }
      })
    },
    goBack() {
      this.form = { ...this.initForm }
      this.choseTableData = []
      this.$emit('closeAddClass')
    },
    async handleOpenDialog(params) {
      this.status = params.status
      if (this.status !== 'add') {
        this.albumId = params.row.id
        const { code, data } = (
          await api3.getCourseList({
            albumId: this.albumId,
          })
        ).data
        console.log('data', data)
        if (code === 100000) {
          let list = []
          data &&
            data.forEach((item) => {
              if (item.checked === 1) {
                list.push(item)
                this.initEidtChoseIds.push(item.id)
              }
            })
          console.log('list', list)
          if (list && list.length) this.choseTableData = list
        }

        this.form = {
          ...params.row,
          videoUndertakingId:
            params.row.videoUndertakingId != null &&
            params.row.videoUndertakingId !== '' &&
            params.row.videoUndertakingId.toString(),
          isOvert: params.row.isOvert.toString(),
          applyType: params.row.applyType && params.row.applyType.toString(),
          signupInfoIds: (params.row.signupInfoIds &&
            params.row.signupInfoIds.split(',')) || ['1', '11'],
        }
        console.log('result', this.choseTableData, this.form)
        this.getMajorList()
        this.form.majorId = params.row.majorId
      }
    },
    handleCourseDtae(type) {
      let now = new Date()
      let date = null
      if (type == 1) {
        date = new Date(this.form.signupStarttime)
      } else if (type == 2) {
        date = new Date(this.form.signupEndtime)
      } else if (type == 3) {
        date = new Date(this.form.openClassTime)
      } else if (type == 4) {
        date = new Date(this.form.closeClassTime)
      }
      return now.getTime() > date.getTime() && this.status !== 'add'
    },
  },
  watch: {
    // 'form.locId': {
    //   immediate: true,
    //   handler(val) {
    //     console.log('form.locId', val)
    //     if (val) {
    //       this.form.majorId = ''
    //       console.log('this.locIdList', this.locIdList)
    //       let obj = this.locIdList.find((item) => item.id === val)
    //       if (obj && obj.code) this.getMajorList(obj.code)
    //     }
    //   },
    // },
    params: {
      immediate: true,
      handler: function (newValue) {
        console.log('params', newValue)

        if (newValue && newValue.status) this.handleOpenDialog(newValue)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  background-color: #fff;
  .verify_desc {
    margin-left: 8px;
    font-size: 14px;
    color: #aaa;
    .tips {
      color: #d9001b;
    }
  }
  .el-row {
    padding: 6px 0;
    border-bottom: 1px dashed #aaa;
    font-size: 14px;
    color: #606266;
  }
  /deep/.el-form-item {
    margin-bottom: 0;
  }
  .el-upload__tip {
    color: #aaa;
  }
  /deep/.ql-container {
    height: 300px;
  }
  /deep/.el-form-item__error {
    position: relative;
  }
  /deep/.el-table__header {
    .gutter {
      background-color: #f2f2f2;
    }
  }
}
</style>